import {OPENGRAPH_API_KEY} from '../constants/APIKeys-obfuscated';
import {OPENGRAPH_API} from '../constants/URLs';
import { openGraphFallbackPreview } from '../utils/Helpers';

export default {
  get: async (siteURL) => {
    try {
        const openGraphResponse = await fetch(
            `${OPENGRAPH_API}/${encodeURIComponent(
            siteURL,
            )}?app_id=${OPENGRAPH_API_KEY}`,
        );
        let openGraphData = await openGraphResponse.json();
        if (openGraphData.error) {
          openGraphData = openGraphFallbackPreview(siteURL, 'web');
        }
        return openGraphData;
    } catch (error) {
      throw error;
    }
  },
};
